import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import TableWrapper from '@/components/table/TableWrapper';
import NoRowsWithPagination from '@/components/table/NoRowsWithPagination';
import { noRowsToDisplay } from '@/components/table/NoRowsWrapper';
import { states } from '@/constants/lifecycle';
import ToggleCardsButton from '@/components/cards/ToggleCardsButton';
import { presentationOptions } from '@/constants/states';
import urls, { codeUrl } from '@/constants/urls';
import { fitToPage, goToCategoryPage } from '@/hooks/paging';
import UserGroupsFilters from '../containers/UserGroupsFilters';
import UserGroupsTableHeader from './UserGroupsTableHeader';
import UserGroupsTableRows from './UserGroupsTableRows';

const UserGroupsTable = ({
  canCreate,
  category,
  className,
  columns,
  currentPage,
  fetchData,
  newUserGroupCode,
  onCheckBoxClick,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  showColumns,
  togglePresentation,
  total,
  userGroups,
}) => {
  const { items, pageNumber } = fitToPage(userGroups, currentPage, pageSize);
  const ref = React.useRef(null);

  return (
    <div className={clsx('ReactTable', className)} ref={ref}>
      <div className={noRowsToDisplay(items, [readStatus], readErrors) ? '' : 'inner'}>
        <TableWrapper sticky celled className="aridhia-user-groups-table" columns={columns}>
          <UserGroupsTableHeader
            category={category}
            columns={columns}
            items={items}
            readErrors={readErrors}
            readStatus={readStatus}
            showColumns={showColumns}
          >
            {togglePresentation && (readStatus !== states.PENDING) && (
              <ToggleCardsButton
                display={presentationOptions.TABLE}
                disabled={readStatus === states.PENDING}
                onClick={() => togglePresentation(category, presentationOptions.CARDS)}
              />
            )}
            <UserGroupsFilters category={category} className="aridhia-table-filter" />
          </UserGroupsTableHeader>
          <Table.Body>
            <UserGroupsTableRows columns={columns} items={items} onCheckBoxClick={onCheckBoxClick} />
          </Table.Body>
        </TableWrapper>
      </div>
      <NoRowsWithPagination
        canCreate={canCreate}
        currentPage={pageNumber}
        entity="usergroup"
        goToPage={({ page }) => goToCategoryPage(fetchData, category, page, ref)}
        icon="users"
        items={items}
        pageCount={pageCount}
        readErrors={readErrors}
        readStatus={readStatus}
        total={total}
        url={codeUrl(urls.USER_GROUP, newUserGroupCode, '#')}
      />
    </div>
  );
};

export default UserGroupsTable;
